import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SessionDto } from '@oracychampions/api-interfaces';
import { catchError, of } from 'rxjs';
import { SessionsService } from '../../session/sessions.service';

export const sessionResolver: ResolveFn<SessionDto | null> = (route, state) => {
  const sessionsService = inject(SessionsService);

  const id = route.params['id'];

  return sessionsService.getSession(id).pipe(
    catchError(() => {
      return of(null);
    }),
  );
};
